import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Typography } from 'antd';

import CalculateCommissionAffiliate from 'components/CalculateCommissionAffiliate';
import PermissionHide from 'v2/components/Shared/PermissionHide';

interface IProps {
  product: any;
  commission?: 'percentage' | 'subscription' | 'normal' | 'coproduction';
}

enum ChargeType {
  SIGNATURE = 'A',
  NORMAL = 'N',
  OPENED = 'L',
  FREE = 'G'
}

const ShowPrice = ({ product, commission }: IProps) => {
  if (product.has_children) {
    return (
      <Typography.Text className='text-content-subtitle/60 m-0 text-sm'>
        <b>Consultar variações</b>
      </Typography.Text>
    );
  }

  if (commission === 'percentage') {
    return (
      <Typography.Text className='text-sm font-bold text-green-600'>
        <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
          {product.coproduction_commission_type == 'P' ? (
            (product.coproduction_commission_percent || 0) + '%'
          ) : (
            <FormattedNumber value={product.coproduction_commission_value || 0} format='BRL' />
          )}
        </PermissionHide>
        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
          <em className='text-content-subtitle/60 font-normal not-italic'>oculto</em>
        </PermissionHide>
      </Typography.Text>
    );
  }

  if (commission === 'subscription') {
    return (
      <Typography.Text className='text-sm font-bold text-green-600'>
        <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
          <FormattedNumber value={product.comission_subscription || 0} format='BRL' />
        </PermissionHide>
        <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
          <em className='text-content-subtitle/60 font-normal not-italic'>oculto</em>
        </PermissionHide>
      </Typography.Text>
    );
  }

  return (
    <div>
      <div className='text-sm font-bold text-green-600'>
        {product.charge_type === ChargeType.SIGNATURE && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            <FormattedNumber value={product.recurring_value || 0} format='BRL' />
            <Typography.Text className='ml-1 font-normal text-green-600'>recorrente</Typography.Text>
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.NORMAL && (
          <Typography.Text className='text-green-600'>
            <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
              <FormattedNumber value={product.price} format='BRL' />
            </PermissionHide>
          </Typography.Text>
        )}

        {(!product.charge_type || product.charge_type === ' ') && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            <FormattedNumber value={0} format='BRL' />
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.OPENED && (
          <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
            Valor Aberto
          </PermissionHide>
        )}

        {product.charge_type === ChargeType.FREE && <Typography.Text>Grátis</Typography.Text>}

        {product.charge_type !== ChargeType.FREE && (
          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
            <em className='text-content-subtitle/60 font-normal not-italic'>oculto</em>
          </PermissionHide>
        )}
      </div>

      {commission === 'normal' && (
        <div className='text-content-subtitle/60 text-xs'>
          {product.charge_type === ChargeType.SIGNATURE && (
            <Typography.Text>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.recurring_value || 0}
                  commissionType={product.recurring_comission_type}
                  commissionValue={product.recurring_comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão recorrente
            </Typography.Text>
          )}

          {product.charge_type === ChargeType.NORMAL && (
            <Typography.Text>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.price || 0}
                  commissionType={product.comission_type}
                  commissionValue={product.comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão
            </Typography.Text>
          )}

          {(!product.charge_type || product.charge_type === ' ') && (
            <Typography.Text>
              <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate price={0} commissionType={'V'} commissionValue={0} />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em className='not-italic'>oculto</em>
              </PermissionHide>{' '}
              de Comissão
            </Typography.Text>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowPrice;
